import { Component, computed, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { ProvidersService } from 'src/app/services/providers.service';
import { StatesService } from 'src/app/services/states.service';
import { ProductsService } from 'src/app/services/products.service';
import { IndustriesService } from 'src/app/services/industries.service';
import { IState } from 'src/app/models/state/state.model';
import { IProduct } from 'src/app/models/product/product.model';
import { IIndustry } from 'src/app/models/Industry/industry.model';
import { IProviderOrganizationDocumentType } from 'src/app/models/provider/provider-license.model';
import { DocumentTypesService } from 'src/app/services/document-types.service';
import { debounceTime, of, Subscription, switchMap, tap } from 'rxjs';
import { Role } from 'src/app/models/user/role.model';
import { DeleteConfirmationDialogService } from 'src/app/services/delete-confirmation-dialog.service';
import { UsersService } from 'src/app/services/users.service';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDrawer, MatSidenavModule } from '@angular/material/sidenav';
import { DatePipe } from '@angular/common';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { entityExistsValidator } from 'src/app/validators/entity-exists.validator';
import { ProviderOrganizationsService } from 'src/app/services/provider.organizations.service';
import { IData, RowDetailsDataComponent } from 'src/app/modules/shared/components/row-detail-data/row-details-data.component';
import { baseColDef } from '../../utils';
import { ColDef, GridApi, GridReadyEvent } from 'ag-grid-community';
import { BtnCellRenderer } from '../../components/btn-cell-renderer/btn-cell-renderer.component';
import { TextTooltipRenderer } from '../../components/text-tooltip-cell-renderer/text-tooltip-cell-renderer.component';
import { toSignal } from '@angular/core/rxjs-interop';
import { formatPhone } from '../../utils/phone.util';
import { PhoneInputDirective } from '../../directives/phone-input.directive';
import { tenDigitPhoneValidator } from '../../validators/phone.validator';
import { MatIconModule } from '@angular/material/icon';
import { AgGridWrapperComponent } from '../../components/ag-grid-wrapper/ag-grid-wrapper.component';
import { RightSidebarContainerComponent } from '../../components/right-sidebar-container/right-sidebar-container.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTabGroup, MatTabsModule } from '@angular/material/tabs';
import { SearchSortComponent } from '../../components/search-sort/search-sort.component';
import { ProviderDocumentsComponent } from '../../components/provider-documents/provider-documents.component';
import { ProviderInvoicesComponent } from './provider-invoices/provider-invoices.component';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { OrgStructureComponent } from '../../components/org-structure/org-structure.component';
import { OrgAssociationsComponent } from "../../components/org-associations/org-associations.component";
import { OrgConsultantsComponent } from '../../components/org-consultants/org-consultants.component';
import { IOrganizationService } from 'src/app/models/muli-org/organization-service.model';
import { FormsInventoryPanelComponent } from '../../components/forms-inventory-panel/forms-inventory-panel.component';
import { MarketingMaterialInventoryPanelComponent } from '../marketing-material-inventory/marketing-material-inventory-panel/marketing-material-inventory-panel.component';
import { CorporateDocumentPanelComponent } from '../corporate-document/corporate-document-panel/corporate-document-panel.component';
import { MiscellaneousDocumentPanelComponent } from '../miscellaneous-document/miscellaneous-document-panel/miscellaneous-document-panel.component';
import { ProviderApprovalPanelComponent } from '../provider-approval/provider-approval-panel/provider-approval-panel.component';
import { ConsultantsService } from 'src/app/services/consultants.service';
@Component({
    selector: 'app-providers-list',
    templateUrl: './providers-list.component.html',
    styleUrls: ['./providers-list.component.scss'],
    standalone: true,
    imports: [
      MatSidenavModule,
      RightSidebarContainerComponent,
      MatFormFieldModule,
      ReactiveFormsModule,
      MatInputModule,
      MatButtonModule,
      RowDetailsDataComponent,
      MatTabsModule,
      SearchSortComponent,
      ProviderDocumentsComponent,
      ProviderInvoicesComponent,
      RouterModule,
      MatIconModule,
      AgGridWrapperComponent,
      MatPaginatorModule,
      MatDatepickerModule,
      PhoneInputDirective,
      FormsInventoryPanelComponent,
      MarketingMaterialInventoryPanelComponent,
      CorporateDocumentPanelComponent,
      MiscellaneousDocumentPanelComponent,
      ProviderApprovalPanelComponent,
      OrgStructureComponent,
      OrgAssociationsComponent,
      OrgConsultantsComponent,
      MatSelectModule
    ]
})
export class ProvidersListComponent implements OnInit {
  public organizationId: any;
  public states: IState[] = [];
  public products: IProduct[] = [];
  public industries: IIndustry[] = [];
  public documentTypes: IProviderOrganizationDocumentType[] = [];
  private organizationLoaded = false;
  private documentTypesLoaded = false;
  public childOrganizations: any[] = [];
  public currentOrganizationName: string = '';
  @ViewChild('orgAssociations') orgAssociationsComponent?: OrgAssociationsComponent;
  @ViewChild('drawer') drawer: MatDrawer;
  @ViewChild('providerTabGroup') tabGroup: MatTabGroup;
    onStructureChanged() {
      if (this.orgAssociationsComponent) {
        this.orgAssociationsComponent.loadOrganizationRelationships();
      }  
      this.loadChildOrganizations(); 
    }
  isEditing = false;
  isLoading: boolean;
  id: number;
  selectedTabIndex: number = -1;

  form: FormGroup = new FormGroup({
    email: new FormControl('', {
      validators: [Validators.email, Validators.required],
      updateOn: 'blur',
    }),
    firstName: new FormControl('', [Validators.required]),
    lastName: new FormControl('', [Validators.required]),
   phoneNumber: new FormControl('', {
      validators: [
        Validators.required,
        tenDigitPhoneValidator(),
      ],
        updateOn: 'blur'
    }),
    organizationId: new FormControl('', [Validators.required]),
    role: new FormControl<number | null>(null, [Validators.required]),
  });

  roleOptions = [
    { id: 3, name: 'Full Access' },
    { id: 6, name: 'Read Only' },
  ];

  pageSettings: {
    defaultPageSize: number;
    pageSizeOptions: number[];
  } = {
    defaultPageSize: 20,
    pageSizeOptions: [20, 50, 100],
  };
  datePipe = new DatePipe('en-US');
  currentPage: number = 0;
  pageSize: number = this.pageSettings.defaultPageSize;
  currentPageInvoices: number = 0;
  pageSizeInvoices: number = this.pageSettings.defaultPageSize;
  dataToShow: any[];
  dataToShowInvoices: any[] = [];

  subscriptions: Subscription[] = [];
  organization: any;
  descriptionRowData: IData[] = [{
    title: 'Description',
    description: '-'
  }];

  searchControl: FormControl = new FormControl('');
  currentSortField = {
    sortValue: 'id',
  };
  currentIsAscending = false;
  totalCount: number = 0;
  searchKey: string = '';

  sortForm: FormGroup = new FormGroup({
    sortField: new FormControl({
      sortValue: this.currentSortField.sortValue,
    }),
    isAscending: new FormControl(this.currentIsAscending),
  });

  sortOptions = [
    { label: 'Name', sortValue: 'firstName' },
    { label: 'Last Name', sortValue: 'lastName' },
    { label: 'Email', sortValue: 'email' },

  ];

  public columnDefs: ColDef[] = [
    {
      ...baseColDef,
      field: 'firstName',
      flex:2,
      cellRenderer: TextTooltipRenderer,
    },
    { ...baseColDef, field: 'lastName', cellRenderer: TextTooltipRenderer, flex:2 },
    { ...baseColDef, field: 'email', cellRenderer: TextTooltipRenderer, flex:3 },
    {
      ...baseColDef,
      field: 'phoneNumber',
      cellRenderer: TextTooltipRenderer,
      flex:2,
      valueFormatter: (params) => formatPhone(params.value),
    },
    {
      ...baseColDef,
      field: 'role',
      headerName: 'Access Level',
      cellRenderer: TextTooltipRenderer,
      flex:2,
      valueFormatter: (params) => params.value === 6 ? 'Read Only' : params.value === 3 ? 'Full Access' : 'N/A',
    }
  ];
  public rowData!: any[];

  readonly userRole = toSignal(this.userService.userRole$, { initialValue: undefined });
  readonly isLender = computed(() => this.userRole() === Role.Lender);
  readonly isAdmin = computed(() => this.userRole() === Role.Admin);
  readonly isProvider= computed(() => this.userRole() === Role.Provider);
  readonly isSystemUser = computed(() => this.userRole() === Role.SystemUser);
  readonly isConsultant= computed(() => this.userRole() === Role.Consultant);
  readonly isProviderReadOnly = computed(() => this.userRole() === Role.ProviderReadOnly);
  readonly isLenderReadOnly = computed(() => this.userRole() === Role.LenderReadOnly);

  gridAPI: GridApi;

  constructor(
    private providerService: ProvidersService,
    private organizationService: ProviderOrganizationsService,
    private route: ActivatedRoute,
    private stateService: StatesService,
    private productsService: ProductsService,
    private industriesService: IndustriesService,
    private deleteDialog: DeleteConfirmationDialogService,
    private userService: UsersService,
    private providerDocumentService: DocumentTypesService,
    private router: Router,
     private consultantsService: ConsultantsService,
  ) {

  }

  get providerOrganizationService(): IOrganizationService {
    return this.organizationService;
  }

  ngOnInit(): void {
    this.initOrganization();
    this.getStates();
    this.getProducts();
    this.getIndustries();
    this.getDocumentTypes();

    const searchSubscription = this.searchControl.valueChanges
    .pipe(
      debounceTime(300),
      tap(() => {
        this.currentPage = 0;
        this.reload();
      }),
    )
    .subscribe();
    this.subscriptions.push(searchSubscription);
  }
  
  private getTabNames(): string[] {
    const pt2 = this.organization.providerType === 2;
    const tabs: string[] = [];

    if (this.isLender() || this.isLenderReadOnly()) {
      if (pt2) tabs.push('forms-management');
      tabs.push('marketing-materials');
      tabs.push(...this.documentTypes.map(dt => dt.name.toLowerCase()));
      tabs.push('approvals', 'corporate-documents', 'miscellaneous-documents');
    } else {
      tabs.push('users', 'relationships');
      if (pt2) tabs.push('forms-management');
      tabs.push('marketing-materials');
      tabs.push(...this.documentTypes.map(dt => dt.name.toLowerCase()));
      tabs.push('approvals', 'corporate-documents', 'miscellaneous-documents');
      if (!this.isSystemUser() && !this.isLender()) tabs.push('invoices');
    }

    return tabs;
  }

  private getTabIndex(tabName: string): number {
    return this.getTabNames().indexOf(tabName);
  }

  private applyQueryParamTab(): void {
    const queryTab = this.route.snapshot.queryParamMap.get('tab');
    if (!queryTab || !this.organization) return;
    const index = this.getTabIndex(queryTab);
    if (index !== -1) this.selectedTabIndex = index;
  }

  private applyDocumentTypeTab(): void {
    const documentTypeId = this.route.snapshot.queryParamMap.get('documentTypeId');
    if (!documentTypeId || this.isLender() || this.isLenderReadOnly()) return;
    if (!this.organization || !this.documentTypes.length) return;

    const targetId = parseInt(documentTypeId);
    const docTypeIndex = this.documentTypes.findIndex(dt => dt.id === targetId);
    if (docTypeIndex !== -1) {
      const baseTabCount = this.getTabIndex('marketing-materials') + 1;
      this.selectedTabIndex = baseTabCount + docTypeIndex;
    }
  }

  // getTabNames() counts document-type tabs to compute indices for every tab after them
  // (Approvals, Corporate Documents, Miscellaneous Documents, Invoices), so both the
  // organization and document-types requests must complete before tab selection runs.
  private applyInitialTabSelection(): void {
    if (!this.organizationLoaded || !this.documentTypesLoaded) return;
    this.selectedTabIndex = 0;
    this.applyQueryParamTab();
    this.applyDocumentTypeTab();
    if (this.tabGroup) {
      this.tabGroup.selectedIndex = this.selectedTabIndex;
    }
  }

  private initOrganization() {
    const userRoleSubscription = this.userService.userRole$.pipe(
          switchMap((role) => {
        const routeId = this.route.snapshot.paramMap.get('id');
          if (routeId) {
            return [routeId];
          } else if (role === Role.Provider || role === Role.ProviderReadOnly) {
              return this.userService.organizationId$;
            } else {
              return [this.route.snapshot.paramMap.get('id')];
            }
          })
        )
        .subscribe((id) => {
          this.organizationId = id ? `${id}` : null;
          this.getOrganization();
          this.loadChildOrganizations();
        });

    this.subscriptions.push(userRoleSubscription);
  }

  onChangeAvailability(data: any) {
    this.deleteDialog
      .openDeleteConfirmation(
        `This provider user will be ${data.isActive ? 'disabled' : 'enabled'}.`,
        data.isActive ? 'Disable confirmation' : 'Enable confirmation',
        data.isActive ? 'Disable' : 'Enable'
      )
      .afterClosed()
      .pipe(
        switchMap((dialogClosed) => {
          if (dialogClosed)
            return this.providerService.changeUserAvailability(
              data.userId,
              !data.isActive
            );
          else return of(false);
        })
      )
      .subscribe((deleteConfirmation) => {
        if (deleteConfirmation) {
          this.reload();
        }
      });
  }
      private loadChildOrganizations() {
        this.childOrganizations = [];
        if (this.isConsultant()) {
          const sub = this.consultantsService
            .getCurrentConsultantAssignedOrganizations()
            .subscribe((response) => {
              if (!response.isError) {
                const currentOrgId = parseInt(this.organizationId);
                this.childOrganizations = response.data.items
                  .filter((org: any) =>
                    org.parentOrganizationId === currentOrgId &&
                    org.id !== currentOrgId
                  );
              }
            });
          this.subscriptions.push(sub);
          return;
        }
        const sub = this.organizationService
          .getRelationships(this.organizationId)
          .subscribe((response) => {
            if (!response.isError) {
              const isParentOrg = response.data.parent === null;
              if (isParentOrg) {
                const allChildren = response.data.children || [];
                this.childOrganizations = allChildren.filter((child: any) => 
                  child.id !== parseInt(this.organizationId)
                );
              }
            }
          });
        this.subscriptions.push(sub);
      }
  onTabChange(event: any) {
    const tabLabel = event.tab?.textLabel;
    const documentTabs = this.documentTypes.map(dt => dt.name);
    if (documentTabs.includes(tabLabel)) {
      this.loadChildOrganizations();
    }
  }
  ngOnDestroy(): void {
    this.subscriptions?.forEach((s) => s.unsubscribe());
  }

  private getProducts() {
    this.productsService.get().subscribe((data: any) => {
      if (!data.isError) {
        this.products = data.data.items;
      }
    });
  }

  private getStates() {
    this.stateService.get().subscribe(data => {
      if (!data.isError) {
        this.states = data.data;
      }
    });
  }
  private getIndustries() {
    this.industriesService.get().subscribe(data => {
      if (!data.isError) {
        this.industries = data.data;
      }
    });
  }
  private getDocumentTypes() {
    this.providerDocumentService.get().subscribe(data => {
      if (!data.isError) {
        this.documentTypes = data.data;
      }
      this.documentTypesLoaded = true;
      this.applyInitialTabSelection();
    });
  }

private getOrganization() {
  this.organizationService.getById(this.organizationId).subscribe((data) => {
    if (!data.isError) {
      this.organization = data.data;
      Promise.resolve().then(() => {
        this.organizationLoaded = true;
        this.applyInitialTabSelection();
      });
      this.currentOrganizationName = data.data.name;
      const addressParts = [];
      if (this.organization.mailingStreetAddress) {
        addressParts.push(this.organization.mailingStreetAddress);
      }
      if (this.organization.mailingStreetAddressLine2) {
        addressParts.push(this.organization.mailingStreetAddressLine2);
      }
      if (this.organization.mailingCity) {
        addressParts.push(this.organization.mailingCity);
      }
      if (this.organization.mailingStateName) {
        addressParts.push(this.organization.mailingStateName);
      }
      if (this.organization.mailingZipCode) {
        addressParts.push(this.organization.mailingZipCode);
      }
      
      const fullAddress = addressParts.length > 0 ? addressParts.join(', ') : '-';
      
      this.descriptionRowData = [
          {
            title: 'Organization Details',
            description: `Email: ${this.organization.email || '-'}\nPhone Number: ${formatPhone(this.organization.phoneNumber) || '-'}\nAddress: ${fullAddress}`
          },

        ]
      }
    });
  }

  openProviderSidebar(data: any = null) {
    if (data) {
      this.id = data.id;
      this.form.controls['email'].setAsyncValidators([
        entityExistsValidator(this.providerService, data.email),
      ]);
      const getSus = this.providerService
        .getById(this.id.toString())
        .subscribe((res) => {
          if (!res.isError) {
            this.form.reset({
              email: res.data.email,
              firstName: res.data.firstName,
              lastName: res.data.lastName,
              phoneNumber: res.data.phoneNumber,
              organizationId: res.data.organizationId,
              role: data.role ?? null,
            });
          }
        });
      this.subscriptions.push(getSus);
      this.isEditing = true;
      this.form.controls['email'].disable();
      this.form.controls['role'].enable();
    } else {
      this.form.controls['organizationId'].setValue(this.organizationId);
      this.form.controls['email'].setAsyncValidators([
        entityExistsValidator(this.providerService),
      ]);
      this.form.controls['email'].enable();
      this.form.controls['role'].enable();
      this.isEditing = false;
    }
    this.form.updateValueAndValidity();
    this.drawer.toggle();
  }

  close() {
    this.form.reset();
    this.drawer.close();
  }

  onSubmit() {
    if (this.form.valid) {
      this.isLoading = true;
      const data = this.form.value;

      if (this.isEditing) {
        const updateSuscription = this.providerService
          .update(this.id.toString(), this.form.getRawValue())
          .subscribe((data) => {
            this.reload();
            this.isLoading = false;
            this.close();
          });
        this.subscriptions.push(updateSuscription);
      } else {
        const addSuscription = this.providerService
          .add(this.form.value)
          .subscribe((data) => {
            this.reload();
            this.isLoading = false;
            this.close();
          });
        this.subscriptions.push(addSuscription);
      }
    }
  }

  private reload() {
    this.isLoading = true;

    if(this.gridAPI) {
      this.gridAPI.showLoadingOverlay();
    }

    this.searchKey = this.searchControl.value?.toLowerCase() || '';
    const subscription = this.providerService
      .getByOrganizationId(this.organizationId, {
        organizationId: this.organizationId,
        sortColumn: this.currentSortField.sortValue,
        sortOrder: this.currentIsAscending ? 'asc' : 'desc',
        page: this.currentPage + 1,
        pageSize: this.pageSize,
        searchKey: this.searchKey
      }).pipe(
        switchMap((response: any) => {
          if (!response.isError) {
            return of(response.data);
          } else {
            return of([]);
          }
        })
      )
      .subscribe((data) => {
        if(this.gridAPI) {
          this.gridAPI.hideOverlay();
        }
        this.rowData = data.items;
        this.totalCount = data.totalCount;
        this.isLoading = false;
        this.form.reset();
        this.drawer.close();
      });
    this.subscriptions.push(subscription);
  }

  setSortField() {
    const { sortField, isAscending } = this.sortForm.value;
    this.currentIsAscending = isAscending;
    this.currentSortField = sortField;

    this.reload();
  }

  resetSortField() {
    this.sortForm.setValue({
      sortField: this.currentSortField,
      isAscending: this.currentIsAscending
    })
  }

  handlePageEvent(event: PageEvent) {
    this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize;
    this.reload();
  }

  //----------GRID FUNCTIONS
  onGridReady(params: GridReadyEvent) {
    this.gridAPI = params.api;
    this.reload();
    this.adjustColumnVisibility(params.api);
  }

  private adjustColumnVisibility(gridApi: any) {
    if(!this.isAdmin()) return;

    const actionCol = {
      field: 'action',
      minWidth: 80,
      maxWidth: 80,
      filter: false,
      sortable: false,
      cellRenderer: BtnCellRenderer,
      cellRendererParams: {
        onEdit: this.isAdmin() ? this.openProviderSidebar.bind(this) : undefined,
        onChangeAvailability: this.isAdmin() ? this.onChangeAvailability.bind(this) : undefined,
      },
    };

    gridApi.setColumnDefs([...this.columnDefs, actionCol]);

  }

  onSubmitFormInventory(formData: any) {
    const userRole = this.userRole();
    let navigationPath: string;

    if (userRole === Role.Admin) {
      navigationPath = '/admin/form-submission/create';
    } else if (userRole === Role.Provider) {
      navigationPath = '/provider/form-submission/create';
    } else if (userRole === Role.SystemUser) {
      navigationPath = '/system-user/form-submission/create';
    } else {
      console.error('Unknown user role for navigation');
      return;
    }

    this.router.navigate([navigationPath], {
      state: { formInventoryData: formData }
    });
  }

}